/* ============================================================
   SENARAI CTA BEG KUNING — bacaan hidup
   ============================================================
   Dipakai oleh DUA skrin: petak CTA di PRO Studio (urus template)
   dan dropdown di Control Panel → tab Schedule (pilih untuk larian).

   ⚠️ SATU hook untuk kedua-duanya, sengaja. Kalau setiap skrin
      membaca sendiri, senarai boleh terpesong — pelanggan memadam
      template di PRO Studio dan dropdown masih menawarkannya.

   `hidup` — beri `false` untuk langsung tidak membaca. Bacaan yang
   tidak dipapar tetap dikira kos.
   ============================================================ */

import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';

import { db, auth } from '../firebase';
import { CTA_COL, bandingCta } from '../utils/ctaStore';

export function useSenaraiCta(hidup = true) {
    /* Satu objek, bukan dua state berasingan — supaya keadaan dikemas kini
       sekali sahaja bagi setiap snapshot. ⚠️ TIADA setState dalam badan
       effect (lint React Compiler menolaknya); keadaan "belum muat"
       dikira pada masa pulang. */
    const [keadaan, setKeadaan] = useState({ senarai: [], sudahMuat: false });

    useEffect(() => {
        const uid = auth.currentUser?.uid;
        if (!hidup || !uid) return undefined;

        const unsub = onSnapshot(
            collection(db, 'users', uid, CTA_COL),
            (snap) => {
                const senarai = snap.docs
                    .map((d) => ({ ...(d.data() || {}), id: d.id }))
                    .filter((x) => String(x.teks || '').trim())
                    .sort(bandingCta);
                setKeadaan({ senarai, sudahMuat: true });
            },
            (e) => {
                /* Gagal baca = senarai kosong, BUKAN skrin rosak. Kesannya
                   pelanggan nampak "belum ada CTA" dan larian jatuh ke teks
                   lalai — sama seperti pelanggan yang memang belum cipta apa-apa. */
                console.warn('[CTA] gagal baca senarai:', e?.message);
                setKeadaan({ senarai: [], sudahMuat: true });
            }
        );
        return () => unsub();
    }, [hidup]);

    return hidup ? keadaan : { senarai: [], sudahMuat: false };
}
